import type { CSSProperties, JSX } from 'react'

import sharedStyles from './chart-shared.module.css'

interface ChartColorDotProps {
  /** Swatch colour: a resolved colour or a `var()` token string. */
  color: string
  /** Render a dashed outline (mirrors a dashed comparison line) instead of a
   *  filled square. */
  dashed?: boolean
  /** Render diagonal stripes (mirrors a hatched comparison bar). */
  hatched?: boolean
}

/**
 * Small colour swatch for chart tooltips and legends — a filled square by
 * default, a dashed outline for comparison lines, or diagonal stripes for
 * hatched comparison bars. Decorative (`aria-hidden`); the adjacent label
 * carries the accessible name.
 */
export function ChartColorDot({
  color,
  dashed = false,
  hatched = false,
}: ChartColorDotProps): JSX.Element {
  const dotStyle: CSSProperties & { '--dot-color': string } = {
    '--dot-color': color,
  }
  const variant = dashed
    ? sharedStyles.colorDotDashed
    : hatched
      ? sharedStyles.colorDotHatched
      : ''
  return (
    <span
      className={`${sharedStyles.colorDot} ${variant}`}
      aria-hidden="true"
      style={dotStyle}
    />
  )
}
